import Http from '../../../helpers/Http'
import { toast } from 'react-toastify'
import { BASE_URL } from '../../../constant'
import axios from 'axios'
import { getUserPreference, printApiError } from '../../../helpers/Util'

export const doFavourite = async (params) => {
    try {
        const { data } = await Http.POST('doFavourite', '', params)
        if (data?.message) {
            toast.success('Added to favourite')
        }
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.warning(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
    }
}

export const doSoldStyleFavourite = async (params) => {
    try {
        const { data } = await Http.POST('doSoldStyleFavourite', '', params)
        if (data?.message) {
            toast.success('Added to Sold Interest folder')
        }
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.warning(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
    }
}

export const undoFavourite = async (designId, folderId) => {
    try {
        let urlParams = '' + designId
        if (folderId) {
            urlParams += `?folderId=${folderId}`
        }
        const { data } = await Http.POST('undoFavourite', '', urlParams)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const addNewFavouriteFolder = async (params) => {
    try {
        const { data } = await Http.POST('addFavouriteFolder', '', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const changeFavouriteFolder = async (
    productId,
    folderId,
    oldFolderId
) => {
    try {
        let params = folderId
            ? `?newFolderId=${folderId}&oldFolderId=${oldFolderId}`
            : ''
        const { data } = await axios.post(
            `${BASE_URL}/product/liked/${productId}/change-folder${params}`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.warning(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchMyFavouriteFolders = async (params) => {
    try {
        const { data } = await Http.GET('getMyFavouriteFolder', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchStyleExistingFolderIds = async (id) => {
    try {
        const { data } = await Http.GET(
            'fetchStyleExistingFolderIds',
            `${id}/folders`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchFolderDetailsById = async (params) => {
    try {
        const { data } = await Http.GET('getFolderDetailsByFolderId', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchFavouriteFolderLists = async (params, requestBody) => {
    try {
        const { data } = await Http.POST(
            'fetchFavouriteFolderList',
            requestBody,
            params
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const modifyFolderName = async (folderId, folderName) => {
    try {
        const { data } = await axios.post(
            `${BASE_URL}/user/favourites/folder/${folderId}/rename?name=${encodeURIComponent(
                folderName
            )}`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const removeFolder = async (folderId) => {
    try {
        const { data } = await axios.delete(
            `${BASE_URL}/user/favourites/folder/${folderId}`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const addMemberToFavourite = async (folderId, memberIds) => {
    try {
        const { data } = await axios.post(
            `${BASE_URL}/user/favourites/folder/${folderId}/add-member?memberIds=${memberIds}`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const inviteMemberFromFavourite = async (postData) => {
    try {
        const { data } = await Http.POST('inviteUserFromFavourite', postData)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchFavouriteDetailsLists = async (params) => {
    try {
        const { data } = await Http.GET('fetchBuyerLikedDesigns', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchFavouriteProductsByFolderId = async (params) => {
    try {
        const { data } = await Http.GET('fetchFavouriteProductId', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const addToDraft = async (params) => {
    try {
        const { data } = await Http.POST('addTodraft', '', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const removeFromdraft = async (params) => {
    try {
        const { data } = await Http.POST('removeFromdraft', '', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchFavouriteDetailsListTableData = async (params) => {
    try {
        const { data } = await Http.GET('fetchBuyerLikedDesignsSummary', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const updateFavourite = async (params) => {
    try {
        const { data } = await Http.POST('updateFavouriteData', '', params)
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchLikedDesignCountByFolder = async (params) => {
    try {
        const { data } = await Http.GET('fetchLikedDesignCount', params)
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const hideLikedProduct = async (params) => {
    try {
        const { data } = await Http.POST('hideLikedDesign', '', params)
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const fetchLikedProductInfoByFolder = async (params) => {
    try {
        const { data } = await Http.GET('getLikedProductInfo', params)
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const approveQuotesByFolder = async (params) => {
    try {
        const { data } = await Http.POST('approveQuoteByFolder', params)
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const getFolderById = async (params) => {
    try {
        const { data } = await Http.GET('getFolderById', params)
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const updateFavouriteFolder = async (queryParam) => {
    try {
        const { data } = await Http.POST('updateFolder', {}, queryParam)
        return data
    } catch (error) {
        printApiError(error)
    }
}
